import React, {useCallback} from "react";
import './RadionicaComponent.scss';
import useEmblaCarousel from "embla-carousel-react";

type RadionicaData = {
    id: string;
    icon: string;
    title: string;
    paragraph1: string;
    paragraph2: string;
    trajanjeParagraph: string;
    carouselImages: string[];
};

type Props = {
    data: RadionicaData;
}

const RadionicaComponentVideo: React.FC<Props> = ( {data} ) => {

    const [emblaRef, emblaApi] = useEmblaCarousel({loop: true});

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev()
      }, [emblaApi])
    
    const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])


    return (
        <div className="radionica-container" id={'scrollElement' + data.id}>
            <div className="radionica-title-container">
                <img src={data.icon} alt="icon" className="radionica-icon"/>
                <h1>{data.title}</h1>
            </div>
            <div className="radionica-paragraph-div">
                <h2>Kome je namenjena radionica i koji je cilj?</h2>
                <p>{data.paragraph1}</p>
            </div>
            <div className="radionica-paragraph-div">
                <h2>Kakav je koncept radionice?</h2>
                <p>{data.paragraph2}</p>
                <p><span className="radionica-bold">Trajanje radionice: </span>{data.trajanjeParagraph}</p>
            </div>
            <div className="radovi-container">
                <h2>Radovi učesnika</h2>
                <div className="carousel-container">
                    <div className="previous-button desktop-sliders" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className='embla' ref={emblaRef}>
                        <div className="embla__container">
                            {data.carouselImages.map((vid, i) => (
                                <div key={i} className="embla__slide">
                                    <video controls src={vid} typeof={'video/mp4'} className="carousel-video">Vaš pretraživač ne podržava video sadržaj.</video>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="next-button desktop-sliders" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="sliders-for-mobile">
                    <div className="previous-button" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="next-button" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RadionicaComponentVideo;